export const resizeImage = (file: File, label: string): Promise<File> => {
  const normalizedLabel = label.toLowerCase();

  let targetWidth: number;
  let targetHeight: number;
  let minOriginalWidth: number;
  let minOriginalHeight: number;

  switch (true) {
    case normalizedLabel.includes('logo'): {
      targetWidth = 500;
      targetHeight = 500;
      minOriginalWidth = 300;
      minOriginalHeight = 300;
      break;
    }

    case normalizedLabel.includes('idproof'): {
      targetWidth = 500;
      targetHeight = 333; // aspect ratio 1.5
      minOriginalWidth = 300;
      minOriginalHeight = 300;
      break;
    }

    case normalizedLabel.includes('banner'): {
      targetWidth = 440;
      targetHeight = 300; // 390 / 1.5
      minOriginalWidth =440;  // or adjust this if needed for mobile
      minOriginalHeight = 300;
      break;
    }


    case normalizedLabel.includes('item image'): {
      targetWidth = 1200;
      targetHeight = 800;
      minOriginalWidth = 800;
      minOriginalHeight = 800;
      break;
    }

    default: {
      targetWidth = 500;
      targetHeight = 500;
      minOriginalWidth = 300;
      minOriginalHeight = 300;
      break;
    }
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const originalWidth = img.width;
        const originalHeight = img.height;

        if (originalWidth < minOriginalWidth || originalHeight < minOriginalHeight) {
          return reject(
            `Image is too small. Minimum size is ${minOriginalWidth}x${minOriginalHeight}. Current size: ${originalWidth}x${originalHeight}`
          );
        }

        const scale = Math.min(targetWidth / originalWidth, targetHeight / originalHeight);
        const newWidth = Math.round(originalWidth * scale);
        const newHeight = Math.round(originalHeight * scale);

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Canvas not supported');

        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: 'image/jpeg',
              });
              resolve(resizedFile);
            } else {
              reject('Blob conversion failed');
            }
          },
          'image/jpeg',
          0.9
        );
      };

      img.onerror = () => reject('Image load error');
      img.src = event.target?.result as string;
    };

    reader.onerror = () => reject('File read error');
    reader.readAsDataURL(file);
  });
};
